import { TitleWrapper, ChartWrapper, Title } from './EsgControversy.styles';
import { useTranslation } from 'react-i18next';
import ControversyBarChart from '@/ui/charts/horizontalBarChart/ControversyBarChart';

const EsgControversy = ({ data, isLoading }) => {
  const [t] = useTranslation('dashboard');

  return (
    <div className="border rounded-lg p-4 h-full space-y-6">
      <TitleWrapper>
        <Title>
          <div className="text-text-500">{t('ESG Controversies')}</div>
          <div className="text-text-200 text-sm">
            {t('ESG risk topics and their proportions for the companies on my watchlist.')}
          </div>
        </Title>
      </TitleWrapper>
      <ChartWrapper>
        <ControversyBarChart data={data} isLoading={isLoading} title="" />
      </ChartWrapper>
    </div>
  );
};

export default EsgControversy;
